<template>
  <div class="component-content">
    <div class="list-title">
      <div class="r">
        <!-- <el-button type="primary" @click="startCreate()" size="mini">新建通知公告</el-button> -->
      </div>


      <el-radio-group size="mini" v-model="relateType">
        <el-radio-button label="0">我发布的</el-radio-button>
        <el-radio-button label="1">我接收的</el-radio-button>
      </el-radio-group>
      <!-- <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select> -->
    </div>

    <div class="ball-loading" v-if="loading">
      <div class="k-ball-holder3">
        <div class="k-ball7a"></div>
        <div class="k-ball7b"></div>
        <div class="k-ball7c"></div>
        <div class="k-ball7d"></div>
      </div>
    </div>
    <div class="card-room" v-else>
      <div class="no-list" v-if="paginationData.length<1">
        <p>暂无与你相关的通知公告</p>
      </div>
      <div class="card-item" v-else v-for="item, i in paginationData">
        <div class="title">
          <h3 class="name">{{item.title}}</h3>
          <p style="margin-top:-15px;">{{item.createTime}}</p>
        </div>
        <div class="info">
          <p><user-info :userData='item.creator'></user-info></p>
          <p v-if="item.attachments && item.attachments.length>0">
            <file-link v-for="item,i in item.attachments" :key="i" :item="item"></file-link>
          </p>
          {{ item.content }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'

  export default {
    components: {
      UserInfo,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 详情
        // noticeStatus: false,
        // noticeDetail: '',
        // isManager: true,

        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表类型 0：我发布的  1：我接收的
        relateType: "0",
        // 列表
        loading: true,
        pageSize: 2000,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      if (!this.userData) {
        return false
      }

      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }

      this.getLists()
    },
    methods: {
      // // 通知公告详情
      // NoticeDetail(row) {
      //   this.noticeStatus = true
      //   ajax.get('/notice/info/' + row.id, "", (res) => {
      //     this.noticeDetail = res.vo
      //   })
      // },
      // hideNoticeDetail() {
      //   this.noticeStatus = false
      //   this.noticeDetail = ""
      // },
      // // 编辑通知公告
      // EditNotice(row) {
      //   this.$router.push('/Notice/Create/' + row.id)
      // },
      // 取消、结束通知公告
      setNoticeState(row, type) {
        switch (type) {
          case 'cancle':
            this.$confirm('此操作将会撤销通知公告，操作结果不可逆，请你确认是否撤销通知公告?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              ajax.post('/notice/del', {
                noticeId: row.id,
              }, (res) => {
                this.$message.success("撤销通知公告成功")
                this.getLists()
              })
            }).catch(() => {});
            break;
          case 'end':
            this.showNoticeSumary(row.id)
            break;
        }
      },
      startCreate() {
        this.$router.push("/Notice/Create")
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/notice/relate/list', {
          type: this.relateType
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'relateType'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/m/notice.vue